/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaricoUpdateDTO
 */
export interface CaricoUpdateDTO {
    /**
     * 
     * @type {Date}
     * @memberof CaricoUpdateDTO
     */
    data?: Date;
    /**
     * 
     * @type {string}
     * @memberof CaricoUpdateDTO
     */
    note?: string | null;
}

/**
 * Check if a given object implements the CaricoUpdateDTO interface.
 */
export function instanceOfCaricoUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CaricoUpdateDTOFromJSON(json: any): CaricoUpdateDTO {
    return CaricoUpdateDTOFromJSONTyped(json, false);
}

export function CaricoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaricoUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : (new Date(json['data'])),
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function CaricoUpdateDTOToJSON(value?: CaricoUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : (value.data.toISOString()),
        'note': value.note,
    };
}

